/* eslint-disable @typescript-eslint/ban-ts-comment */
export const AnalyticsWidget =
    (widgetName?: string) =>
    <T extends new (...args: any[]) => unknown>(constructor: T) =>
        // @ts-ignore
        class extends constructor {
            analyticsWidgetName = widgetName;
        };
